import { Button, Form, notification, Popconfirm } from "antd";
import React, { useEffect, useState } from "react";
import { MultiLanguageInput } from "../../../Components/MultiLanguageInput";
import { editBettingWebsiteTitle, getBettingWebsiteByID } from "../action";
import { useParams } from "react-router-dom";
import { PiPlus } from "react-icons/pi";
import { TbEditCircle } from "react-icons/tb";

type Props = {
  fetchData: () => void;
};
interface FormValues {
  title: {
    en: string;
    ar: string;
    fr: string;
  };
}
const EditTitle = (props: Props) => {
  const [form] = Form.useForm<FormValues>();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const fetchItem = async () => {
    setIsLoading(true);
    const website = await getBettingWebsiteByID(id!);
    if (website)
      form.setFieldsValue({
        title: {
          en: website?.MainInfo.Title.En,
          ar: website?.MainInfo.Title.Ar,
          fr: website?.MainInfo.Title.Fr,
        },
      });
    setIsLoading(false);
  };
  const handleSubmit = async () => {
    try {
      const formValues = await form.validateFields();
      setIsLoading(true);

      const data = await editBettingWebsiteTitle(id!, formValues.title);

      if (data) {
        props.fetchData();
        api.success({
          message: "Betting website edited successfully",
        });
      }
    } catch (err: any) {
      api.error({
        message: "Failed to edit betting website",
        description:
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Unexpected error occurred",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchItem();
  }, [id]);

  return (
    <Form form={form} layout="vertical">
      {contextHolder}

      <MultiLanguageInput name="title" label="Title" />

      <Form.Item shouldUpdate>
        {() => (
          <Popconfirm
            title="Are you sure you want to edit this title?"
            onConfirm={handleSubmit}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<TbEditCircle />}
              loading={isLoading}
              type="primary"
              className="w-full"
              disabled={
                !form.isFieldsTouched(true) ||
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
            >
              {isLoading ? "Editing Title..." : "Edit Title"}
            </Button>
          </Popconfirm>
        )}
      </Form.Item>
    </Form>
  );
};

export default EditTitle;
